import { useState } from 'react'
import Header from '../../components/Header'
import Title from '../../components/Title'
import { FaCity } from "react-icons/fa";
import { db } from '../../services/firebaseConnection'
import { addDoc, collection } from 'firebase/firestore'
import { useNavigate } from 'react-router-dom';
import { toast, } from 'react-toastify'

export default function Cidade() {
  const [nome, setNome] = useState('')
  const navigate = useNavigate();


  async function handleRegister(e) {
    e.preventDefault();

    if (nome !== '') {
      await addDoc(collection(db, "Cidade"), {
        nome: nome


      })
        .then(() => {
          setNome('')
          toast.success("cidade registrada!")
          navigate('/cidade');
        })
        .catch((error) => {
          console.log(error);
          toast.error("Erro ao fazer o cadastro.")
        })

    } else {
      toast.error("Preencha todos os campos!")
    }

  }

  return (
    <div>
      <Header />

      <div className="content">
        <Title name="Cidade">
          <FaCity size={25} />
        </Title>

        <div className="container">
          <form className="form-profile" onSubmit={handleRegister}>
            <label>Nome</label>
            <input
              type="text"
              placeholder="Nome da cidade"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />

            <button type="submit">
              Salvar
            </button>
          </form>
        </div>

      </div>

    </div>
  )
}